import { Component, EventEmitter, Input, Inject, Output } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import { Classifier, CountryService } from '@nano/common/classifier';
import { Institution } from '@nano/common/finance';
import { FormService } from '@nano/common/form';
import { PaymentConfig } from '@nano/payment/payment';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-beneficiary-bank-details',
  templateUrl: './beneficiary-bank-details.component.html',
  standalone: false
})
export class BeneficiaryBankDetailsComponent {
  countries$: Observable<Classifier[]> = this.countryService.worldwideCountries$;
  @Output() institutionSelected = new EventEmitter<Institution | null>();

  @Input() form: FormGroup;
  @Input() config: PaymentConfig;
  @Input() userMustProvideInstitution: boolean;
  @Input() beneficiaryBankIdentifierControl: AbstractControl;
  @Input() beneficiaryBankNameControl: AbstractControl;
  @Input() beneficiaryBankCountryControl: AbstractControl;
  @Input() beneficiaryBankAddressControl: AbstractControl;

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private formService: FormService,
    private countryService: CountryService
  ) {}

  onInstitutionSelect(institution: Institution | null): void {
    if (institution) {
      this.formService.switchFormControlsEnabled(this.form, ['beneficiaryBankName', 'beneficiaryBankAddress', 'beneficiaryBankCountry'], !institution);
      this.beneficiaryBankNameControl.setValue(institution.name);
      this.beneficiaryBankNameControl.disable();
      this.beneficiaryBankAddressControl.setValue(institution.address);
      this.beneficiaryBankCountryControl.setValue(institution.country);
      this.form.get('instructionIdentification')?.setValue(institution.instructionIdentification);
    } else {
      this.beneficiaryBankNameControl.reset();
      this.beneficiaryBankAddressControl.reset();
      this.beneficiaryBankCountryControl.reset();
      this.form.get('instructionIdentification')?.reset();
    }

    this.formService.switchFormControlsEnabled(this.form, ['beneficiaryBankName', 'beneficiaryBankAddress', 'beneficiaryBankCountry'], !institution);
    this.institutionSelected.emit(institution || null);
  }
}
